import { useEffect, useMemo, useRef, useState } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { useOnSaleEventsContext } from 'src/contexts/OnSaleEventsContext/OnSaleEventsContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './OnSaleEventDetails.css';

const descriptionMaxWidth = 64;

export const PerformerDescription = () => {
  const { categoryResults, event } = useOnSaleEventsContext();

  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const eventCategoryResult = useMemo(() => {
    if (!event?.performer?.viagId || !categoryResults) {
      return null;
    }
    return categoryResults[event?.performer?.viagId] ?? null;
  }, [categoryResults, event?.performer?.viagId]);

  useEffect(() => {
    if (contentRef.current) {
      const isOverflowing =
        contentRef.current.scrollHeight > descriptionMaxWidth;
      setShowToggle(isOverflowing);
    }
  }, [eventCategoryResult?.description]);

  if (
    !eventCategoryResult?.description ||
    eventCategoryResult?.description.length <= 0
  ) {
    return null;
  }

  return (
    <Stack
      width="full"
      direction="column"
      gap="s"
      className={styles.performerDescriptionContainer}
    >
      <div
        ref={contentRef}
        className={styles.performerDescription}
        style={{
          maxHeight: expanded ? 'none' : `${descriptionMaxWidth}px`,
          lineHeight: vars.typography.lineHeight.base,
        }}
      >
        {eventCategoryResult.description}
      </div>
      {showToggle && (
        <button
          className={styles.performerDescriptionToggleButton}
          onClick={() => setExpanded(!expanded)}
        >
          <Content id={expanded ? ContentId.ShowLess : ContentId.ShowMore} />
        </button>
      )}
    </Stack>
  );
};
